export default "__VITE_ASSET__Dpz2k69k__"